import Flex from '@Components/Bases/Flex';
import { FormTextEditor } from '@Components/Form';
import FormRadio from '@Components/Form/FormRadio';
import { disabledFormInputStyles } from '@Components/Form/styles';
import { Alert, Box, InputLabel, styled, Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { VerifyType } from 'src/Enum/EsgGreenhouse';
import PerformanceGhgasMgmtRemark from './PerformanceGhgasMgmtRemark';
import PerformanceGhgasMgmtUploadImage from './PerformanceGhgasMgmtUploadImage';

const LabelStyles = styled(InputLabel)({
  width: '100%',
  minWidth: 200,
  maxWidth: 350,
  textAlign: 'right',
  whiteSpace: 'inherit',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-end',
  '&& .MuiInputLabel-asterisk': {
    whiteSpace: 'nowrap',
  },
});

const operationResultOptions = [
  { label: 'มี', value: VerifyType.YES },
  { label: 'ไม่มี', value: VerifyType.NO },
];

const PerformanceGhgasMgmt = () => {
  const { control, watch, setValue, trigger } = useFormContext();

  const performanceGhGasMgmtReport = watch('performanceGhGasMgmtReport');

  const { isCompletedTh = false, isCompletedEn = false } =
    performanceGhGasMgmtReport?.completedSection ?? {};

  const result = useWatch({
    control,
    name: 'performanceGhGasMgmtReport.performanceGhGasMgmt.result',
  });

  const isResultSelected =
    result === VerifyType.YES || result === VerifyType.NO;

  const isResult = result === VerifyType.YES;

  return (
    <>
      <Flex gap={1} my={2} alignItems={'center'}>
        <Typography fontWeight={800}>
          ผลการดำเนินงานและผลลัพธ์ด้านการจัดการก๊าซเรือนกระจก
        </Typography>
        <Flex gap={0.5} alignItems={'center'}>
          <PerformanceGhgasMgmtRemark />
        </Flex>
      </Flex>
      <Alert severity="info">
        <Flex>
          คำชี้แจง :
          <Box pl={1}>
            <ul style={{ paddingLeft: 16, margin: 0 }}>
              <li>กรณีเลือก “มี” ต้องอธิบายผลการดำเนินงานและผลลัพธ์</li>
              <li>
                กรณีเลือก “ไม่มี”
                สามารถอธิบายผลการดำเนินงานและผลลัพธ์ที่คาดว่าจะเกิดขึ้น (ถ้ามี)
              </li>
            </ul>
          </Box>
        </Flex>
      </Alert>
      <Flex mt={2} gap={2}>
        <Flex justifyContent={'end'} minWidth="350px">
          <LabelStyles required>
            ผลการดำเนินงานและผลลัพธ์ด้านการจัดการจัดการก๊าซเรือนกระจก
          </LabelStyles>
        </Flex>
        <Flex width={'100%'}>
          <FormRadio
            sx={{ flexDirection: 'column' }}
            name="performanceGhGasMgmtReport.performanceGhGasMgmt.result"
            options={operationResultOptions}
            disabled={isCompletedTh || isCompletedEn}
            onChange={(event) => {
              const value = event.target.value;
              setValue(
                'performanceGhGasMgmtReport.performanceGhGasMgmt.result',
                value
              );
              if (value === VerifyType.YES) {
                trigger(
                  'performanceGhGasMgmtReport.performanceGhGasMgmt.result'
                );
              } else {
                trigger([
                  'performanceGhGasMgmtReport.performanceGhGasMgmt.result',
                  'performanceGhGasMgmtReport.performanceGhGasMgmt.descriptionTh',
                  'performanceGhGasMgmtReport.performanceGhGasMgmt.descriptionEn',
                ]);
              }
            }}
          />
        </Flex>
      </Flex>

      <FormTextEditor
        name="performanceGhGasMgmtReport.performanceGhGasMgmt.descriptionTh"
        label="กรุณาอธิบายผลการดำเนินงานและผลลัพธ์ด้านการจัดการก๊าซเรือนกระจก เช่น โครงการและ/หรือรางวัลที่ได้รับ (ไทย)"
        required={isResult}
        inputProps={{
          placeholder: 'กรุณาระบุ (ไทย)',
        }}
        mt={2}
        sx={
          !isResultSelected || isCompletedTh
            ? disabledFormInputStyles
            : undefined
        }
      />
      <FormTextEditor
        name="performanceGhGasMgmtReport.performanceGhGasMgmt.descriptionEn"
        label={
          'กรุณาอธิบายผลการดำเนินงานและผลลัพธ์ด้านการจัดการก๊าซเรือนกระจก เช่น โครงการและ/หรือรางวัลที่ได้รับ (อังกฤษ)'
        }
        required={isResult}
        inputProps={{ placeholder: 'กรุณาระบุ (อังกฤษ)' }}
        mt={2}
        sx={
          !isResultSelected || isCompletedEn
            ? disabledFormInputStyles
            : undefined
        }
      />
      <PerformanceGhgasMgmtUploadImage
        isCompletedEn={isCompletedEn}
        isCompletedTh={isCompletedTh}
      />
    </>
  );
};

export default PerformanceGhgasMgmt;
